import axios from 'axios';

export interface ScopeDef {
  value: string;
  label: string;
  description: string;
  group: string;
}

export const AVAILABLE_SCOPES: ScopeDef[] = [
  {
    group: 'Scans',
    value: 'scan:submit',
    label: 'Submit scans',
    description: 'Queue repositories for analysis',
  },
  {
    group: 'Scans',
    value: 'scan:read',
    label: 'Read results',
    description: 'Read analyses and scan results',
  },
  {
    group: 'Repositories',
    value: 'repo:read',
    label: 'Read repositories',
    description: 'List and read your repositories',
  },
  {
    group: 'Providers',
    value: 'provider:connect',
    label: 'Connect providers',
    description: 'Connect and inspect source provider accounts',
  },
  {
    group: 'Maintenance tasks',
    value: 'tasks:run',
    label: 'Run tasks',
    description: 'Start, retry, and manage maintenance tasks',
  },
  {
    group: 'Maintenance tasks',
    value: 'tasks:read',
    label: 'Read tasks',
    description: 'List maintenance tasks and read status',
  },
];

export const SCOPE_GROUPS = AVAILABLE_SCOPES.reduce<Record<string, ScopeDef[]>>((acc, s) => {
  (acc[s.group] ??= []).push(s);
  return acc;
}, {});

export const EXPIRY_PRESETS: { label: string; days: number | null }[] = [
  { label: '30 days', days: 30 },
  { label: '90 days', days: 90 },
  { label: '180 days', days: 180 },
  { label: '1 year', days: 365 },
  { label: 'Never', days: null },
];

export function formatDate(value: string | null): string {
  if (!value) return 'never';
  return new Date(value).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

// Whole days from now until end of the picked day; null if empty/past.
export function daysUntil(dateStr: string): number | null {
  if (!dateStr) return null;
  const ms = new Date(`${dateStr}T23:59:59`).getTime() - Date.now();
  return ms > 0 ? Math.ceil(ms / 86_400_000) : null;
}

export function minExpiryDate(): string {
  return new Date(Date.now() + 86_400_000).toISOString().slice(0, 10);
}

export function errorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) return err.response?.data?.error || err.message || fallback;
  return err instanceof Error ? err.message : fallback;
}
